var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHighlightSeats = function SvgHighlightSeats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M16.288 21.99h-6.195c-1.012 0-2.028-.02-3.042.005a1.07 1.07 0 0 1-.638-.138A.96.96 0 0 1 6 21.38c-.444-.879-.911-1.75-1.376-2.615-.274-.508-.507-1.024-.077-1.55.2-.236.472-.41.78-.498.306-.09.635-.09.943-.003 1.762.31 3.522.63 5.28.942.827.147 1.654.287 2.633.456-.148-.296-.22-.471-.319-.631a5.2 5.2 0 0 1-.937-3.29 5.28 5.28 0 0 1 1.318-3.171 39 39 0 0 1 3.43-3.513c.432-.417.48-.686 0-1.075a2.3 2.3 0 0 1-.897-1.128 2.15 2.15 0 0 1-.02-1.407c.181-.47.49-.888.894-1.213a3.2 3.2 0 0 1 1.416-.645c.515-.151.555.152.555.495 0 1.327-.113 2.665.016 3.979.355 3.68-1.027 7.057-1.948 10.517-.432 1.65-.924 3.283-1.402 4.958",
    clipRule: "evenodd"
  })));
};
export default SvgHighlightSeats;